<template>
  <naj-modal
    ref="modal"
    :title="local.redistribution.modalTitle"
    :width="900"
    :footer="true"
    @onClose="closeModal"
  >
    <v-form
      ref="servicesCenterRedistributionForm"
      class="services-center-redistribution-form"
    >
      <naj-input
        class="department-type-input"
        :label="`${local.redistribution.redistributionLawsuitRequestsTo}:`"
        :type-id="formFieldType.radioButton"
        :value.sync="employeeType"
        :items="employeeTypesOptions"
        item-value="id"
        item-text="name"
        validates="required"
        @change="employeeTypeChangeHandler"
      ></naj-input>
      <div class="employees-list">
        <div
          v-if="loadingEmployees"
          class="employees-loader"
        >
          <naj-loader></naj-loader>
        </div>
        <naj-input
          v-if="employeeType"
          :type-id="formFieldType.selectbox"
          :items="servicesCenterEmployees[employeeType]"
          :value.sync="employeeId"
          item-text="name"
          item-value="id"
          :label="local.redistribution.selectEmployee"
        ></naj-input>
      </div>
    </v-form>
    <template
      slot="actions"
      slot-scope="{ closeNajModal }"
    >
      <naj-button
        :disabled="employeeId == null || loading"
        :loading="loading"
        @click="submit(closeNajModal)"
      >
        {{ local.common.save }}
      </naj-button>
    </template>
  </naj-modal>
</template>

<script>
import { servicesCenterEmployeeType } from '@/helpers/enum';
import { createNamespacedHelpers } from 'vuex';

const { mapActions } = createNamespacedHelpers('LawsuitModule');
const { mapState: mapLUTState, mapActions: mapLUTActions } = createNamespacedHelpers(
  'LookupsModule'
);

export default {
  name: 'ServicesCenterRedistributionModal',
  props: ['modalVisibility', 'selectedRequests'],
  data () {
    return {
      employeeId: null,
      loading: false,
      loadingEmployees: false,
      employeeType: null,
    };
  },
  mounted () {},
  computed: {
    ...mapLUTState(['servicesCenterEmployees']),
    employeeTypesOptions () {
      return Object.keys(servicesCenterEmployeeType).reduce((typesOptions, type) => {
        return typesOptions.concat(servicesCenterEmployeeType[type]);
      }, []);
    },
  },
  methods: {
    ...mapActions(['submitServicesCenterRedistribution']),
    ...mapLUTActions(['getServicesCenterEmployees']),
    closeModal () {
      this.$emit('onClose');
    },
    submit () {
      this.$validator.validateAll().then((valid) => {
        if (valid) {
          this.loading = true;
          const payload = this.selectedRequests.reduce((requests, request) => {
            return requests.concat({
              newUserId: this.employeeId || null,
              objectKey: request.objectKey,
              employeeType: this.employeeType,
            });
          }, []);
          this.submitServicesCenterRedistribution(payload)
            .then(() => {
              this.loading = false;
              this.employeeId = null;
              this.employeeType = null;
              this.$emit('successSubmit');
              this.closeModal();
              this.toaster.success(this.local.redistribution.successMessage);
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },
    employeeTypeChangeHandler () {
      this.loadingEmployees = true;
      this.getServicesCenterEmployees(this.employeeType).finally(() => {
        this.loadingEmployees = false;
      });
    },
    resetForm () {
      this.employeeType = null;
      this.employeeId = null;
      this.$refs.servicesCenterRedistributionForm.$validator.reset();
    },
  },
  watch: {
    modalVisibility (newValue) {
      if (newValue) {
        this.$refs.modal.show();
      } else {
        this.$refs.modal.close();
        this.resetForm();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.headline {
  background-color: #075848 !important;
  color: #fff;
  padding: 15px 25px;
}
.modal-content {
  padding: 20px;
}
.department-type-input {
  max-width: 350px;
}
.employees-list {
  position: relative;
  .employees-loader {
    position: absolute;
    top: -5px;
    bottom: 0;
    right: 0;
    left: 0;
    background-color: rgba(255, 255, 255, 0.6);
    z-index: 3;
  }
}
</style>
